import { Link } from 'react-router-dom';

export default function CFIsPricing() {
  return (
    <section className="py-24 px-6 bg-[#0A1628]">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-br from-emerald-500/10 via-teal-500/10 to-blue-500/10 rounded-3xl border border-emerald-500/20 p-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl"></div>
          
          <div className="relative z-10">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/20 border border-emerald-500/30 rounded-full mb-6">
                <i className="ri-vip-crown-fill text-emerald-400 text-lg"></i>
                <span className="text-emerald-400 font-semibold text-sm">CFI & School Plans</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold mb-4">
                Flexible Pricing for Instructors
              </h2>
              <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                Whether you're an independent CFI or managing a flight school, we have a plan that fits your needs
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 mb-10">
              <div className="bg-[#1a2942]/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/50">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-emerald-500/20 flex items-center justify-center">
                    <i className="ri-user-star-line text-emerald-400 text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white">Individual CFI</h3>
                    <p className="text-gray-400 text-sm">Perfect for independent instructors</p>
                  </div>
                </div>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-3 text-gray-300">
                    <i className="ri-check-line text-emerald-400 text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Unlimited student tracking</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-300">
                    <i className="ri-check-line text-emerald-400 text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Full debrief & replay tools</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-300">
                    <i className="ri-check-line text-emerald-400 text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Progress reports & analytics</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-300">
                    <i className="ri-check-line text-emerald-400 text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Priority support</span>
                  </li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-emerald-500/20 to-teal-500/20 backdrop-blur-sm rounded-2xl p-8 border border-emerald-500/30 relative">
                <div className="absolute top-4 right-4 px-3 py-1 bg-emerald-500 text-white text-xs font-bold rounded-full whitespace-nowrap">
                  MOST POPULAR
                </div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-emerald-500/30 flex items-center justify-center">
                    <i className="ri-building-line text-emerald-400 text-2xl"></i>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white">Flight School</h3>
                    <p className="text-gray-300 text-sm">For schools & multi-CFI operations</p>
                  </div>
                </div>
                <ul className="space-y-3 mb-6">
                  <li className="flex items-start gap-3 text-gray-200">
                    <i className="ri-check-line text-emerald-400 text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Everything in Individual CFI</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-200">
                    <i className="ri-check-line text-emerald-400 text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Multi-instructor dashboard</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-200">
                    <i className="ri-check-line text-emerald-400 text-xl flex-shrink-0 mt-0.5"></i>
                    <span>School-wide analytics</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-200">
                    <i className="ri-check-line text-emerald-400 text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Custom branding options</span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-200">
                    <i className="ri-check-line text-emerald-400 text-xl flex-shrink-0 mt-0.5"></i>
                    <span>Dedicated account manager</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="text-center">
              <Link
                to="/pricing"
                className="inline-flex items-center gap-2 px-8 py-4 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/30 whitespace-nowrap"
              >
                View Full Pricing Details
                <i className="ri-arrow-right-line text-xl"></i>
              </Link>
              <p className="text-gray-400 text-sm mt-4">
                <i className="ri-calendar-check-line text-emerald-400 mr-2"></i>
                30-day free trial • No credit card required • Cancel anytime
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}